import styled from 'styled-components/macro'
import { commonModalStyle, commonModalContentStyle } from 'src/global/helpers'

export const Wrapper = styled.div`
  ${commonModalStyle}
  width: min(700px, calc(100vw - 16px));
  background: ${props => props.theme.pageBackground};
  border: 1px solid ${props => props.theme.border};
  transition: opacity 0.25s ease-in-out;
  color: ${props => props.theme.normalText};
  box-shadow: 0 4px 42px ${props => props.theme.shadow};
  overflow: hidden;

  &.closed {
    pointer-events: none;
    opacity: 0;
  }
`

export const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: ${props => props.theme.pageBackground};
  font-size: 18px;
`

export const ModalContent = styled.div`
  ${commonModalContentStyle}
  padding: 0 16px;

  .step {
    background: ${props => props.theme.white};
    border: 1px solid ${props => props.theme.border};
    border-radius: 12px;
    margin-bottom: 12px;
    overflow: hidden;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .step-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 20px;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background: ${props => props.theme.activeBackground};
    }

    h3 {
      margin: 0;
      font-size: 17px;
      font-weight: 600;
    }

    .chevron {
      color: ${props => props.theme.mutedText};
      font-size: 14px;
      transition: transform 0.3s ease;
      margin-left: auto;
    }
  }

  .step.active .step-header .chevron {
    transform: rotate(180deg);
  }

  .step-body {
    max-height: 0;
    overflow: hidden;
    transition:
      max-height 0.35s ease,
      padding 0.35s ease;
    padding: 0 20px;
  }

  .step.active .step-body {
    max-height: 600px;
    padding: 0 20px 20px;
  }

  .step-number {
    padding: 6px 12px;
    background: ${props => props.theme.accent};
    color: #fff;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    flex-shrink: 0;
    white-space: nowrap;
  }

  .step-description {
    margin: 8px 0 8px 0;
    color: ${props => props.theme.normalText};
    text-align: center;
  }

  .app-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-weight: 600;
    color: ${props => props.theme.darkBlue};
    vertical-align: middle;

    img {
      width: 20px;
      height: 20px;
      border-radius: 4px;
      box-shadow: 0 0 4px ${props => props.theme.shadow};
    }
  }

  .qr-code-wrapper {
    position: relative;
    margin: 0 auto;
    padding: 12px;
    border: 3px solid ${props => props.theme.accent};
    background: #fff;
    border-radius: 14px;
    width: fit-content;

    .qr-code {
      width: 180px;
      display: block;
      border-radius: 8px;
    }

    .center-icon {
      width: 30px;
      height: 30px;
      border-radius: 8px;
      padding: 5px;
      position: absolute;
      background: #fff;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    }

    &.login-qr {
      border-color: ${props => props.theme.orange};

      .qr-code {
        width: 350px;
      }

      .center-icon {
        color: ${props => props.theme.orange};
        width: 32px;
        height: 32px;
      }
    }
  }

  .store-badges-label {
    margin: 16px 0px 4px;
    font-size: 14px;
    color: ${props => props.theme.mutedText};
    text-align: center;
  }

  .store-badges {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;

    a {
      display: block;
      transition:
        transform 0.15s ease,
        opacity 0.15s ease;

      &:hover {
        transform: scale(1.03);
        opacity: 0.9;
      }
    }

    img {
      height: 44px;
      display: block;
    }
  }

  .next-step-button {
    margin: 20px auto 0;
  }

  @media (max-width: 768px) {
    padding: 12px;

    .step-header {
      padding: 14px 16px;

      h3 {
        font-size: 16px;
      }
    }

    .step-body {
      padding: 0 16px;
    }

    .step.active .step-body {
      padding: 0 16px 16px;
    }

    .qr-code-wrapper .qr-code {
      width: 160px;
    }

    .qr-code-wrapper.login-qr .qr-code {
      width: 300px;
      max-width: 100%;

      @media (max-width: 768px) {
        width: 170px;
      }
    }
  }
`

export const ModalFooter = styled.div`
  border-top: 1px solid ${props => props.theme.border};
  padding: 12px 16px;
  background: ${props => props.theme.pageBackground};
  display: flex;
  justify-content: center;

  button {
    margin-top: 0;
  }
`
